export default __webpack_public_path__ + "static/media/google-play-badge.f902960a.png";